// JOBE-0044.6: EntityTypesContext — the route-level seam JOBE-0044.13
// (inspector preview driver) and JOBE-0044.14 (Cedar-denied detect)
// both consume.
//
// Canonical tri-state shape (referenced verbatim by .13 and .14):
//   { status: 'loading' | 'ready' | 'error', types: EntityTypeRow[], error: string | null }
//
// The provider (EntityTypesProvider.jsx) owns the single GET
// /api/entity-types fetch and broadcasts the result. Consumers must
// distinguish `loading` ("haven't fetched yet") from `ready` + empty
// ("fetched and got empty"); a `loading` value must not be misread as
// Cedar-denied.

import { createContext } from 'react';

// Default value matches the `loading` branch of the tri-state. Used by
// useContext readers that render outside the provider (test harnesses
// that mount a block in isolation; the value is shaped correctly so
// consumers don't need to null-check).
export const ENTITY_TYPES_INITIAL = Object.freeze({
  status: 'loading',
  types: [],
  error: null,
});

export const EntityTypesContext = createContext(ENTITY_TYPES_INITIAL);
